import { apiSlice } from "./apiSlice"

export enum DataProviders {
    S3DataProvider = "S3MultiLevelDataProvider",
    SSHDataProvider = "UserkeyFlatDirSshDataProvider",
}

export type DestinationLocation = SshDestinationLocation | S3DestinationLocation;

export type SshDestinationLocation = {
    name: string,
    type: "UserkeyFlatDirSshDataProvider",
    hostName: string,
    userName: string,
    path: string,
    port: string,
    project: number | string
}

export type S3DestinationLocation = {
    name: string,
    type: "S3MultiLevelDataProvider",
    clientIdentifier: string,
    clientToken: string,
    bucketName: string,
    startPath: string,
    endpoint: string,
    region: string,
}

export type DataProviderType = "UserkeyFlatDirSshDataProvider" | "S3MultiLevelDataProvider";

export type DataProvider = {
    id: number,
    remote_user: string,
    remote_host: string,
    remote_dir: string,
    remote_port: number,
    name: string,
    type: DataProviderType,
    user_id: number,
    group_id: number,
    online: boolean,
    read_only: boolean,
    description: string,
    is_browsable: boolean,
    is_fast_syncing: boolean,
    allow_file_owner_change: boolean,
    content_storage_shared_between_users: boolean
}

export type Group = {
    description: string,
    id: number,
    invisible: boolean,
    name: string,
    site_id: number,
    type: string,
}

export type DataProvidersResponse = {
    data_providers: DataProvider[],
    meta: {
        groups: Group[],
        public_key: string,
    }
}

export const dataProvidersApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDataProviders: builder.query<DataProvidersResponse, any>({
            query: () => "/data_provider",
            providesTags: ["Data_Providers"]
        }),
        addDestinationLocation: builder.mutation({
            query: (payload: DestinationLocation) => {
                return {
                    url: '/data_provider',
                    method: 'POST',
                    body: { ...payload }
                }
            },
            invalidatesTags: ["Data_Providers"]
        },),
        healthCheck: builder.mutation({
            query: (id: number) => {
                return {
                    url: `/data_provider/${id}/check_health`,
                    method: 'POST',
                }
            },
            invalidatesTags: ["Data_Providers"]
        }),
        background: builder.query({
            query: () => "/data_download"
        })
    }),
});


export const { useGetDataProvidersQuery, useAddDestinationLocationMutation, useHealthCheckMutation, useBackgroundQuery } = dataProvidersApiSlice;